import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { auth, db } from '../firebase'
import {
  collection,
  doc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  deleteDoc,
  QuerySnapshot,
  DocumentData
} from 'firebase/firestore'
import { FaRegTrashAlt } from 'react-icons/fa'
import { GoTriangleDown } from 'react-icons/go'
import { toast } from 'react-toastify'

import { convertTime } from '../helpers/datetime_helper'
import Layout from '../components/layout'
import MainTitle from '../components/main_title'
import Spinner from '../components/spinner'
import { getIconBySentiment } from '../components/icons'
import { User } from 'firebase/auth'
import { IJournal } from '../types/journal'

function Journals() {
  const user = auth.currentUser as User

  const [loading, setLoading] = useState(true)
  const [journals, setJournals] = useState<IJournal[]>([])
  const [selected, setSelected] = useState<string | null>(null)

  useEffect(() => {
    function convert(querySnap: QuerySnapshot<DocumentData>) {
      const ret: IJournal[] = []

      querySnap.forEach((doc) => {
        const docInfo = doc.data()
        const row: IJournal = {
          uid: user.uid,
          id: doc.id,
          title: docInfo.title,
          date: docInfo.date,
          content: '',
          sentiment: docInfo.sentiment
        }
        return ret.push(row)
      })

      return ret
    }

    const fetchListings = async () => {
      try {
        // Get reference
        const journalRef = collection(db, 'journals')

        // Create a query
        const q = query(
          journalRef,
          where('uid', '==', user.uid),
          orderBy('date', 'desc'),
          limit(10)
        )

        // Execute query
        const querySnap = await getDocs(q)
        const formatted = convert(querySnap)
        setJournals(formatted)
        setLoading(false)
      } catch (err) {
        console.error(`Could not fetch listings: ${err}`)
      }
    }

    fetchListings()
  }, [user])

  async function deleteJournal(journal_id_to_delete: string) {
    await deleteDoc(doc(db, 'journals', journal_id_to_delete))
    const updatedJournals = journals.filter(
      (journal) => journal.id !== journal_id_to_delete
    )
    setJournals(updatedJournals)
    toast.success('Successfully deleted a journal')
  }

  function select(journal: IJournal) {
    setSelected(journal.id)
  }

  function unselect() {
    setSelected(null)
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <Layout>
      <MainTitle title="Journals" />
      <div>
        <div
          className="flex w-full items-center justify-between rounded-2xl bg-tertiary p-4 text-white shadow-xl"
          onClick={unselect}
        >
          <div className="flex items-center justify-between rounded-2xl bg-secondary px-6 py-1">
            <div className="flex items-center">
              <GoTriangleDown /> &nbsp;&nbsp;Title
            </div>
          </div>
          <div>
            Journals Count: {journals.length} Selected = {selected}
          </div>
        </div>

        {journals.map((el, idx) => {
          return (
            <div
              key={idx}
              className="my-4 flex w-full justify-between rounded-3xl border-2 p-4 shadow-xl"
              onClick={() => {
                select(el)
              }}
            >
              <div>
                <Link to={`/journals/${el['id']}`}>
                  <div className="text-2xl hover:underline">{el['title']}</div>
                </Link>
              </div>

              <div className="flex justify-between">
                <div className="mr-6 flex items-center justify-center">
                  {getIconBySentiment(el['sentiment'], 50)}
                </div>
                <div>
                  <Link to={`/journals/${el['id']}`}>
                    <div className="inline-block align-middle">
                      {convertTime(el['date'])}
                    </div>
                  </Link>
                  <div className="flex items-center justify-between">
                    <Link
                      to={`/journals/${el['id']}/edit`}
                      className="rounded-2xl bg-secondary px-4 py-1 text-white"
                    >
                      Edit
                    </Link>
                    <div
                      className="hover:text-red-500"
                      onClick={() => {
                        if (
                          window.confirm(
                            `Are you sure you wish to delete ${el['id']}`
                          )
                        )
                          deleteJournal(el['id'])
                      }}
                    >
                      <FaRegTrashAlt
                        size={20}
                        className="inline-block align-middle"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Layout>
  )
}

export default Journals
